import { ActionContext } from 'vuex'
import apiAdminMissionVirtual from '@/api/admin/missionVirtual'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IMissionVirtualState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import { WobSimProgress } from '@/models/wob/WobSimProgress'
import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import { ISmartResult } from '@/models/iris/smartMission/ISmartResult'
import { containsExtent } from 'ol/extent'
import { getSimulationStatus, getSimulationStatusTradKey, SimulationStatus } from '@/enum/SimulationStatus'
import { AloMission } from '@/models/alo/AloMission'
import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'
import {i18n} from '@/locale/vueI18n'
import Vue from 'vue'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { SoundNotification } from '@/enum/SoundNotification'

export class MissionVirtualAction {
   
  public [types.MISSIONVIRTUAL_REQUEST](context: ActionContext<IMissionVirtualState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.MISSIONVIRTUAL_REQUEST)
        apiAdminMissionVirtual
          .getMissionVirtuals()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const missionVirtualArray = resp.data.data as AloBaseArray<AloDbMissionVirtual>
              context.dispatch(types.UI_ENSURE_MISSION_STATE, { ids: missionVirtualArray.items.map(m => m.id), typeUiid: 'global' }).then(()=>{
                context.commit(types.MISSIONVIRTUAL_SUCCESS, missionVirtualArray.items)
                resolve(missionVirtualArray.items)
              })              
            } else {
              context.commit(types.MISSIONVIRTUAL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.MISSIONVIRTUAL_ERROR)
            reject()
          })
      })
  }

  public [types.MISSIONVIRTUAL_ENSURE_LIST](context: ActionContext<IMissionVirtualState, IRootState>) {
    if(context.state.missionVirtuals.length == 0) {
        return context.dispatch(types.MISSIONVIRTUAL_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.missionVirtuals)            
        })
    }    
  }

  public [types.MISSIONVIRTUAL_SELECT_DETAIL](context: ActionContext<IMissionVirtualState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const missionVirtual = context.getters.missionVirtualsById[itemId] as AloDbMissionVirtual      
      if(missionVirtual) {        
        if(missionVirtual.detailLoaded) {
          context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL,missionVirtual)
          resolve(missionVirtual)
        }
        else{
          context.dispatch(types.MISSIONVIRTUAL_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newMissionVirtual = new AloDbMissionVirtual()
        context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL,newMissionVirtual)
        resolve(newMissionVirtual)
      }
    })
  }

  public [types.MISSIONVIRTUAL_SELECT_DETAIL_REQUEST](context: ActionContext<IMissionVirtualState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_REQUEST, itemId)
        apiAdminMissionVirtual
          .getMissionVirtual(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const missionVirtual = resp.data.data as AloDbMissionVirtual
              context.dispatch(types.UI_ENSURE_MISSION_STATE, { ids: [missionVirtual.id], typeUiid: 'global' })
              context.dispatch(types.UI_ENSURE_MISSION_STATE, { ids: [missionVirtual.id], typeUiid: 'detail' }).then(()=>{
                context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_SUCCESS, missionVirtual)
                context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL,missionVirtual)
                resolve(missionVirtual)
              })              
            } else {
              context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.MISSIONVIRTUAL_SAVE_REQUEST](context: ActionContext<IMissionVirtualState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmMissionVirtual.id
        context.commit(types.MISSIONVIRTUAL_SAVE_REQUEST,context.state.modifiedAdmMissionVirtual.VIM_LIBELLE)
        apiAdminMissionVirtual
          .saveMissionVirtual(context.state.modifiedAdmMissionVirtual)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const missionVirtual = resp.data.data as AloDbMissionVirtual            
              context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_SUCCESS, missionVirtual)
              context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL,missionVirtual)               
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:missionVirtual.VIM_LIBELLE}))
              if(tryRedirect && router.app.$route.name === 'NewMissionVirtual') router.push({name:'EditMissionVirtual',params:{missionVirtualid:missionVirtual.id!.toString()}})
              resolve(missionVirtual)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.MISSIONVIRTUAL_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.MISSIONVIRTUAL_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }


  public [types.MISSIONVIRTUAL_DELETE_REQUEST](context: ActionContext<IMissionVirtualState, IRootState>,mission:AloDbMissionVirtual) {
    return new Promise<void>((resolve, reject) => {      
      const missionId = mission?mission.id!:context.state.originalAdmMissionVirtual.id!
      const missionLabel = mission?mission.VIM_LIBELLE:context.state.originalAdmMissionVirtual.VIM_LIBELLE          

      context.commit(types.MISSIONVIRTUAL_DELETE_REQUEST, missionLabel)
      apiAdminMissionVirtual
        .deleteMissionVirtual(missionId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context.commit(types.MISSIONVIRTUAL_DELETE_SUCCESS, missionId)            
            resolve()
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MISSIONVIRTUAL_DELETE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorDelete',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MISSIONVIRTUAL_DELETE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorDelete',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnDelete'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONVIRTUAL_UPDATE_MODIFIED_ADM](context: ActionContext<IMissionVirtualState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONVIRTUAL_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmMissionVirtual)
    })
  }
  
  public [types.MISSIONVIRTUAL_CANCEL_MODIFIED_ADM](context: ActionContext<IMissionVirtualState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL,context.state.originalAdmMissionVirtual)
      resolve(context.state.modifiedAdmMissionVirtual)
    })
  }

  public [types.MISSIONVIRTUAL_UPDATE_FILTER_ADM](context: ActionContext<IMissionVirtualState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONVIRTUAL_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }

  public [types.MISSIONVIRTUAL_PROGRESSION_REQUEST](context: ActionContext<IMissionVirtualState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.MISSIONVIRTUAL_PROGRESSION_REQUEST, itemId)
        apiAdminMissionVirtual
          .getMissionResult(itemId)
          .then(resp => {            
            const missionvirtual = context.getters.missionVirtualsById[itemId] as AloDbMissionVirtual           
            if(missionvirtual) missionvirtual.mission._detailLoaded = true            
            const mission = context.rootGetters.missionsById[itemId] as AloMission
            if(mission && mission.simulation) {
              mission.simulation._detailLoaded = true
            }            
            if (resp.data.resultCode == ApiResultCode.Ok) {                                     
              const fakeWob = {
                irisRawResult:JSON.stringify(resp.data.data),
                irisResult:resp.data.data,
                misId:itemId
              }        
              context.dispatch(types.MISSIONVIRTUAL_UPDATE_PROGRESSION, fakeWob)              
              context.dispatch(types.MISSION_ENDMISSION_UPDATE_PROGRESSION, fakeWob)
              resolve(missionvirtual)
            } else {
              context.commit(types.MISSIONVIRTUAL_PROGRESSION_ERROR)
              const missionvirtual = context.getters.missionVirtualsById[itemId] as AloDbMissionVirtual 
              if(missionvirtual) {
                missionvirtual.mission._detailLoaded = true
                missionvirtual.VIM_STATUS = SimulationStatus.failed
                apiAdminMissionVirtual.saveMissionVirtual(missionvirtual)      
              }              
              const mission = context.rootGetters.missionsById[itemId] as AloMission
              if(mission && mission.simulation) {
                mission.simulation._detailLoaded = true                  
                mission.vimStatus = SimulationStatus.failed
              }
              apiAdminMissionVirtual.updateStatus(itemId,SimulationStatus.failed)
              
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            const missionvirtual = context.getters.missionVirtualsById[itemId] as AloDbMissionVirtual        
            if(missionvirtual) {
              missionvirtual.mission._detailLoaded = true
              missionvirtual.VIM_STATUS = SimulationStatus.failed            
              apiAdminMissionVirtual.saveMissionVirtual(missionvirtual)      
            }            
            const mission = context.rootGetters.missionsById[itemId] as AloMission
            if(mission && mission.simulation) {
              mission.simulation._detailLoaded = true                  
              mission.vimStatus = SimulationStatus.failed
            }
            apiAdminMissionVirtual.updateStatus(itemId,SimulationStatus.failed)            
            //TODO Ajouter eventuellement une erreur
            context.commit(types.MISSIONVIRTUAL_PROGRESSION_ERROR)
            reject()
          })
      })
  }

  

  public async [types.MISSIONVIRTUAL_UPDATE_PROGRESSION](context: ActionContext<IMissionVirtualState, IRootState>, wob:WobSimProgress) {        
          
      const missionvirtual = context.getters.missionVirtualsById[wob.misId] as AloDbMissionVirtual
      //console.log("missionvirtual",missionvirtual)
      if(missionvirtual) {
        
        const status =  getSimulationStatus(wob.simulationState)
        if(missionvirtual.VIM_STATUS != status) {
          //si le status a changé et que la simulation est finie on affiche un message
          switch(status ) {
            case SimulationStatus.finished:              
            case SimulationStatus.error:
            case SimulationStatus.aborted:
            case SimulationStatus.failed:                
                if((missionvirtual.missionBase.MIG_ID && context.rootState.missionGlobal.simuLaunchDic[missionvirtual.missionBase.MIG_ID]) || context.state.vimLaunchDic[missionvirtual.id!]) {
                  if(missionvirtual.missionBase.MIG_ID) 
                    context.rootState.missionGlobal.simuLaunchDic[missionvirtual.missionBase.MIG_ID] = false                  
                  else
                    context.state.vimLaunchDic[missionvirtual.id!] = false                  
                  // pour notif simulation
                  if( context.rootGetters.soundNotification == SoundNotification.Enable){
                    var audio = new Audio('/glass.mp3')
                    Vue.nextTick(() => { audio.play() })
                  }
                  //@ts-ignore                
                  context.state.showDialogSimulationFinished = i18n.t('Messages.SimulationEnded',{simu:missionvirtual.missionBase.MIS_LIBELLE?.replace('_', missionvirtual.missionBase.MIG_ID?' #':'_'),status:i18n.t(getSimulationStatusTradKey(status))})
                  //i18n.t('Messages.SimulationEnded',{simu:'',status:i18n.t(getSimulationStatusTradKey(status))}) 
                  //context.dispatch(types.UI_ADD_SNACK_MESSAGE, i18n.t('Messages.SimulationEnded',{simu:'',status:i18n.t(getSimulationStatusTradKey(status))}) )   
                  //@ts-ignore    
                }            
                break;          
            default:    
                break
          } 
        }
        context.commit(types.MISSIONVIRTUAL_UPDATE_PROGRESSION,{missionvirtual,wob})  

        if(missionvirtual.missionBase.MIG_ID)    {
          const map_uiid = buildSimulationUIStateId(missionvirtual.missionBase.MIG_ID!,"map")
          context.dispatch(types.UI_SELECT_MISSION_MAP,{id:wob.misId,uiid:map_uiid})
        }
      }
      else {                
        if((context.state.missionVirtuals?.length ?? 0) == 0) await context.dispatch(types.MISSIONVIRTUAL_REQUEST)        
        else {
          context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_REQUEST, wob.misId)
          try {
            const resp = await apiAdminMissionVirtual.getMissionVirtual(wob.misId)
              
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire              
              const missionVirtual = resp.data.data as AloDbMissionVirtual
              await context.dispatch(types.UI_ENSURE_MISSION_STATE, { ids: [missionVirtual.id], typeUiid: 'global' })
              await context.dispatch(types.UI_ENSURE_MISSION_STATE, { ids: [missionVirtual.id], typeUiid: 'detail' })             
              context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_SUCCESS, missionVirtual)                
            } else {
              context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_ERROR)                
            }
          }
          catch{
            context.commit(types.MISSIONVIRTUAL_SELECT_DETAIL_ERROR)              
          }                        
        }
        //TODO regarder si une MIG avec le simulation name et la company existe et si oui requeter les missions virtuelles.
        const mig = (context.rootGetters.missionGlobals as Array<AloDbMissionGlobal> ?? []).find(m => m.MIG_KEY == wob.simulationName)                
        if(mig && mig.misIdArray.every(id => id != wob.misId))  {
          mig.misIdArray.push(wob.misId)
        }
      }
      return wob
  }  
  public [types.MISSIONVIRTUAL_RESET_SHOW_DIALOG_FINISHED](context: ActionContext<IMissionVirtualState, IRootState>) {
    return new Promise<void>((resolve, reject) => { 
      context.commit(types.MISSIONVIRTUAL_RESET_SHOW_DIALOG_FINISHED); 
      resolve();
    })
  }
  public [types.MISSIONVIRTUAL_ENSURE_DATA_SCIENCE](context: ActionContext<IMissionVirtualState, IRootState>, missionId:number) {
    const missionvirtual = context.getters.missionVirtualsById[missionId] as AloDbMissionVirtual    
    if (!missionvirtual?.mission?._dataScienceLoaded ?? false) {
      return context.dispatch(types.MISSIONVIRTUAL_DATA_SCIENCE_REQUEST, {id:missionId,targetYosCycles:null})
    } else {
      return new Promise((resolve, reject) => {
        if (!missionvirtual?.mission) {  
          reject()
        } else {
          resolve(missionvirtual.mission.dataScience)
        }
      })
    }
  }
  

  public [types.MISSIONVIRTUAL_DATA_SCIENCE_REQUEST](context: ActionContext<IMissionVirtualState, IRootState>,  {id,targetYosCycles}:{id:number,targetYosCycles:Array<number>|null})  {    
    return new Promise((resolve, reject) => {      
      context.commit(types.MISSIONVIRTUAL_DATA_SCIENCE_REQUEST, id) 
      apiAdminMissionVirtual
        .getDataScience(id,targetYosCycles)
        .then(resp => {          
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const datas = resp.data.data
            //context.commit les données de la mission
            context.commit(types.MISSIONVIRTUAL_DATA_SCIENCE_SUCCESS, { id, datas, targetYosCycles })
            resolve(datas)
          } else {
            context.commit(types.MISSIONVIRTUAL_DATA_SCIENCE_ERROR, id)
            reject()
          }
        })
        .catch(error => {
          context.commit(types.MISSIONVIRTUAL_DATA_SCIENCE_ERROR, id)
          reject()
        })
    })
  }
}

export default util.classToObject(MissionVirtualAction)
